// Coordinates overlapping content-browser loads.
//
// The browser reloads whenever content changes (e.g. dragging kanban cards
// bumps a cache key). Each load cancels the previous in-flight request, so a
// superseded request settles as a rejection and load() resolves to `undefined`.
// Because reloads overlap, those completions race: without arbitration a
// cancelled load's `undefined` can land after the winning load's data and
// blank the list until the next reload.
//
// A load is identified by a monotonically increasing token from begin().
// Only the most-recently-started load may write the view, and a cancelled or
// failed load (result === undefined) is never allowed to overwrite data.
export function createLoadSequencer() {
  let generation = 0;
  return {
    // Call at the start of every load(); returns this load's token.
    begin() {
      return ++generation;
    },
    // True while `token` identifies the most recently started load.
    // Use mid-flight to abandon a load that a newer one has superseded.
    isCurrent(token) {
      return token === generation;
    },
    // Whether a completed load may write its result to the view. Drops
    // superseded loads and cancelled/failed loads (undefined), so a
    // late-resolving cancelled request can never blank the list.
    accepts(token, result) {
      return token === generation && result !== undefined;
    },
  };
}
